module.exports = __webpack_public_path__ + "static/media/point_rouge.4f774989.svg";